module.exports = __webpack_public_path__ + "media/images/common/ico-gift-b1ea05968c43ed715128d1167dc57ad3.svg";